import React from 'react';

const Certificate = () => {
  return (
    <section className="certificate-section">
      <div className="certificate-top-bg"></div>
      
      <div className="certificate-main">
        <div className="container">
          <div className="certificate-wrapper">
            <div className="certificate-info">
              <h2 className="certificate-title">CERTIFICADO DE CONCLUSÃO</h2>
              <p className="certificate-description">
                Após concluir o Curso Expert em Henna, você terá acesso a um lindo certificado de conclusão que você poderá emitir direto da sua área do aluno.
              </p>
            </div>
            
            <div className="certificate-visual">
              <div className="certificate-card">
                <div className="certificate-card-decoration certificate-card-decoration-top-left"></div>
                <div className="certificate-card-decoration certificate-card-decoration-bottom-right"></div>
                <div className="certificate-card-content">
                  <div className="certificate-card-header">
                    <span className="certificate-course-name">curso expert em henna</span>
                  </div>
                  <div className="certificate-card-title">CERTIFICADO</div>
                  <div className="certificate-card-text">
                    Conferimos o presente certificado à
                  </div>
                  <div className="certificate-card-name">Ana Campos de Souza</div>
                  <div className="certificate-card-details">
                    por sua participação no Expert em Henna com carga horária de 12 horas. Realizado em 25/12/2025
                  </div>
                  <div className="certificate-card-footer">
                    <div className="certificate-card-signature-name">ANA CAMPOS DE SOUZA</div>
                    <div className="certificate-card-student">Aluno (a)</div>
                  </div>
                  <div className="certificate-card-signature">
                    Letícia Venâncio
                  </div>
                </div>
              </div>              
            </div>
          </div>
        </div>
      </div>
      
      <div className="certificate-bottom-bg"></div>
    </section>
  );
};

export default Certificate;

